import SmartAppBannerToolbar from "./SmartAppBannerToolbar";

export default SmartAppBannerToolbar;
